import { useEffect, useState } from 'preact/hooks';
import { selectedProperty, setSelectedProperty } from './state';
import { api } from './api';

interface Property {
  id: string;
  name: string;
  is_default: boolean;
}

const PropertiesSelect = () => {
  const [properties, setProperties] = useState<Property[]>([]);

  useEffect(() => {
    api('/properties')
      .then((data: Property[]) => {
        setProperties(data);
        const url = new URL(window.location.href);
        const hasLeadFilterWithoutProperty = Boolean(url.searchParams.get('lead_id')) && !url.searchParams.get('property');

        if (hasLeadFilterWithoutProperty && !selectedProperty.value) {
          return;
        }

        if (data.length > 0) {
          const defaultProperty = data.find((prop) => prop.is_default);
          const hasCurrentProperty = data.some((prop) => prop.id === selectedProperty.value);
          setSelectedProperty(
            hasCurrentProperty
              ? selectedProperty.value
              : defaultProperty?.id ?? data[0]?.id ?? '',
            { updateUrl: true }
          );
        }
      });
  }, []);

  return (
    <div className="control-group">
      <select
        onChange={(e) => {
          setSelectedProperty((e.currentTarget as HTMLSelectElement).value);
        }}
        value={selectedProperty.value || ''}
      >
        {properties.map(property => (
          <option key={property.id} value={property.id}>
            {property.name}
          </option>
        ))}
      </select>
    </div>
  );
};

export default PropertiesSelect;
